import { AppointmentClockData } from "@/models/appointment.model";
import { Clock, MapPin } from "lucide-react";

interface ClockSummaryProps {
  clockIn?: AppointmentClockData;
  clockOut?: AppointmentClockData;
}

function formatTime(isoString: string) {
  return new Date(isoString).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function getDuration(start: string, end: string) {
  const diff = new Date(end).getTime() - new Date(start).getTime();
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}h ${minutes}m`;
}

export function ClockSummary({ clockIn, clockOut }: ClockSummaryProps) {
  if (!clockIn?.time) return null;

  return (
    <div className="bg-muted/50 rounded-lg p-4 space-y-3">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Clock className="w-4 h-4" />
        Work Time
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm">
        <div>
          <p className="text-xs text-muted-foreground uppercase">Started</p>
          <p className="font-medium">{formatTime(clockIn.time)}</p>
          {clockIn.lat != null && clockIn.lng != null && (
            <p className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
              <MapPin className="w-3 h-3" />
              Location recorded
            </p>
          )}
        </div>
        {clockOut?.time && (
          <>
            <div>
              <p className="text-xs text-muted-foreground uppercase">Finished</p>
              <p className="font-medium">{formatTime(clockOut.time)}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground uppercase">Duration</p>
              <p className="font-medium">{getDuration(clockIn.time, clockOut.time)}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
